import { Check } from "@mui/icons-material";
import { FC, useState } from "react";
import styled from "styled-components";

const CardProgressContainer = styled.div<{
  $active?: boolean;
  $after?: boolean;
}>`
  position: relative;  
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ $after, $active, theme }) =>
    $after &&
    `
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 3px;
      background-color: ${$active ? theme.success : theme.border};
      top: 50%;
      left: 100%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }
  `}
`;

const IconProgress = styled.div<{ $active?: boolean }>`
  position: relative;
  display: flex;
  background-color: ${({ $active, theme }) =>
    $active ? theme.success : theme.backgroundStageIcon};
  color: ${({ $active, theme }) => ($active ? "#FFF" : theme.text)};
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  font-size: 1.5em;
  border-radius: 50%;
  position: relative;
  z-index: 2;
`;
const Title = styled.div`
  color: ${({ theme }) => theme.text};
  position: absolute;
  bottom: 5px;
`;

interface CardProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  width: string;
  height: string;
  namberPage: number;
  showAfter?: boolean;
  active?: boolean;
  setActiveShow?: (value: boolean) => void;
}

const CardProgress: FC<CardProgressProps> = ({
  title,
  namberPage,
  width,
  height,
  showAfter = true,
  active = false,
}) => {
  return (
    <CardProgressContainer
      $active={active}
      $after={showAfter}
      style={{ width: width, height: height }}
    >
      <IconProgress $active={active}>
        {!active ? namberPage : <Check fontSize="large" />}
      </IconProgress>
      <Title>{title}</Title>
    </CardProgressContainer>
  );
};

export default CardProgress;
